import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IonCol, IonGrid, IonItem, IonRow, IonSkeletonText } from '@ionic/angular/standalone';

@Component({
  selector: 'lib-skeleton-item-two-columns',
  templateUrl: './skeleton-item-two-columns.component.html',
  styleUrls: ['./skeleton-item-two-columns.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonItem, IonCol, IonRow, IonSkeletonText, IonGrid],
})
export class SkeletonItemTwoColumnsComponent {
  // constructor() {}
}
